import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setAxiosNavigate } from "../config/axiosConfig.js";

function useAxiosNavigation() {
	const navigate = useNavigate();

	useEffect(() => {
		setAxiosNavigate(navigate);

		return () => setAxiosNavigate(null);
	}, [navigate]);
}
export default useAxiosNavigation;
